/* KZK Ön Talep Formu
 * Stoğu biten iç giyim (tag: ontalep) ürünlerinde, içgiyim matrisine benzer
 * (Renk x Beden) bir talep formu kurar. Sepet/checkout YOK; talep doğrudan
 * KZK backend'ine (/api/on-talep/submit) gönderilir. Beden başına min adet kuralı uygulanır.
 */
(function () {
  'use strict';

  const CFG = window.KZK_ONTALEP_CONFIG || {};
  const API_BASE = window.KZK_API_BASE || 'https://senko.tunnel.patronundan.com.tr';
  const API = API_BASE + '/api/on-talep/submit';
  const MIN = Number(CFG.minAdet) || 10;
  const CUP_MAP = { '33': 'B', '34': 'C', '35': 'D', '37': 'E', '38': 'F' };

  function parseCup(handle) {
    if (!handle) return '';
    return CUP_MAP[String(handle).slice(0, 2)] || '';
  }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  ready(function () {
    const root = document.getElementById('kzk-ontalep');
    if (!root) return;

    // Talep formunu satın alma bölgesinin KARDEŞİ olarak taşı. (Eskiden mount'un İÇİNE
    // konuyordu; artık "Ön Talep" modunda #qv-inline-mount gizleniyor, form içindeyse o da
    // gizlenirdi. Kardeş yapınca form bağımsız görünür/gizlenir.)
    const mount = document.getElementById('qv-inline-mount');
    if (mount && mount.parentNode) { mount.parentNode.insertBefore(root, mount.nextSibling); }

    const matrixEl = root.querySelector('#kzk-ontalep-matrix');
    const errEl = root.querySelector('#kzk-ontalep-error');
    const totalEl = root.querySelector('#kzk-ontalep-total');
    const submitBtn = root.querySelector('#kzk-ontalep-submit');

    const pd = window.productData;
    if (!pd || !Array.isArray(pd.variants) || !pd.variants.length) {
      matrixEl.innerHTML = '<div style="color:#c00">Ürün verisi bulunamadı.</div>';
      return;
    }

    // Renk (option1) ve Beden (option2) indekslerini tespit et
    const optNames = (pd.options || []).map(o => String(o || '').toLowerCase());
    let colorIdx = optNames.findIndex(o => o.indexOf('renk') !== -1 || o.indexOf('color') !== -1);
    let sizeIdx = optNames.findIndex(o => o.indexOf('beden') !== -1 || o.indexOf('size') !== -1);
    if (colorIdx === -1) colorIdx = 0;
    if (sizeIdx === -1) sizeIdx = (colorIdx === 1 ? 0 : 1);
    const optKey = (i) => 'option' + (i + 1);

    // Renk ve Beden değerlerini varyantlardan sıralı benzersiz topla.
    // YENİ MODEL: SADECE stoğu biten (available === false) varyantlar ön-talebe girer;
    // stokta olan renk/beden "Stoktan Al" tarafında normal satılır.
    const colors = [], sizes = [], vmap = {};
    pd.variants.forEach(v => {
      if (v.available !== false) return; // stokta olanı ön-talep matrisine ALMA
      const c = v[optKey(colorIdx)] || '';
      const s = v[optKey(sizeIdx)] || '';
      if (c && colors.indexOf(c) === -1) colors.push(c);
      if (s && sizes.indexOf(s) === -1) sizes.push(s);
      vmap[c + '|' + s] = v;
    });

    if (!colors.length || !sizes.length) {
      matrixEl.innerHTML = '<div style="color:#555">Bu üründe ön-talebe açık (stoğu tükenmiş) varyant bulunmuyor.</div>';
      if (submitBtn) submitBtn.style.display = 'none';
      return;
    }

    const cup = parseCup(pd.handle);

    // Matris tablosu kur
    let html = '<table class="kzk-ot-table"><thead><tr><th></th>';
    sizes.forEach(s => { html += '<th>' + esc(s) + '</th>'; });
    html += '</tr></thead><tbody>';
    colors.forEach(c => {
      html += '<tr><td class="kzk-ot-renk">' + esc(c) + '</td>';
      sizes.forEach(s => {
        const v = vmap[c + '|' + s];
        if (v) {
          html += '<td><input type="number" min="0" step="1" value="0" inputmode="numeric" class="kzk-ot-input"'
            + ' data-variant="' + esc(v.id) + '"'
            + ' data-color="' + encodeURIComponent(c) + '"'
            + ' data-size="' + encodeURIComponent(s) + '"></td>';
        } else {
          html += '<td class="kzk-ot-empty">-</td>';
        }
      });
      html += '</tr>';
    });
    html += '</tbody></table>';
    matrixEl.innerHTML = html;

    const inputs = Array.prototype.slice.call(root.querySelectorAll('.kzk-ot-input'));

    function grandTotal() {
      let t = 0;
      inputs.forEach(i => { t += Math.max(0, parseInt(i.value, 10) || 0); });
      return t;
    }
    function sizeTotals() {
      const m = {};
      inputs.forEach(i => {
        const s = decodeURIComponent(i.dataset.size);
        m[s] = (m[s] || 0) + Math.max(0, parseInt(i.value, 10) || 0);
      });
      return m;
    }
    function refresh() { totalEl.textContent = 'Toplam: ' + grandTotal() + ' adet'; }
    inputs.forEach(i => i.addEventListener('input', refresh));

    submitBtn.addEventListener('click', async function () {
      errEl.textContent = '';

      const items = [];
      inputs.forEach(i => {
        const q = Math.max(0, parseInt(i.value, 10) || 0);
        if (q > 0) {
          items.push({
            variantId: i.dataset.variant,
            color: decodeURIComponent(i.dataset.color),
            size: decodeURIComponent(i.dataset.size),
            cup: cup,
            quantity: q
          });
        }
      });

      if (!items.length) { errEl.textContent = 'Lütfen en az bir beden için adet giriniz.'; return; }

      // Beden başına minimum adet kuralı (0 veya >= MIN)
      const st = sizeTotals();
      for (const s in st) {
        if (st[s] > 0 && st[s] < MIN) {
          errEl.textContent = '"' + s + '" bedeni için en az ' + MIN + ' adet talep edilmelidir (şu an ' + st[s] + ').';
          return;
        }
      }

      const cust = window.customerData || {};
      submitBtn.disabled = true;
      const oldText = submitBtn.textContent;
      submitBtn.textContent = 'Gönderiliyor...';

      try {
        const r = await fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            brand: 'kzk',
            productHandle: pd.handle,
            productTitle: pd.title,
            productSku: (pd.variants[0] && pd.variants[0].sku) || '',
            cup: cup,
            items: items,
            customer: { id: cust.id || null, email: cust.email || '', name: cust.name || '' }
          })
        });
        const j = await r.json();
        if (j && j.ok) {
          try { sessionStorage.removeItem('kzk_ontalep_handles_' + String(cust.email || '').trim().toLowerCase()); } catch (e) {}
          root.innerHTML = '<div class="kzk-ot-success">Ön talebiniz alındı! Yeterli talep toplandığında üretim yapılacaktır. Teşekkür ederiz.</div>';
        } else {
          errEl.textContent = (j && j.error) || 'Talep gönderilemedi.';
          submitBtn.disabled = false;
          submitBtn.textContent = oldText;
        }
      } catch (e) {
        errEl.textContent = 'Bağlantı hatası: ' + e.message;
        submitBtn.disabled = false;
        submitBtn.textContent = oldText;
      }
    });

    refresh();
  });
})();
